<script setup lang="ts">
import { useEvent } from '@desktop/views/Relation/composables'

const { event } = useEvent()
</script>

<template>
  <div class="text-center text-xs">
    {{ event.status_name }}
  </div>
</template>
